import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Moment from 'moment';

import IESurveyListRows from './IESurveyListRows';

const IESurveyTable = ({ surveyList }) => {
  const initialState = {
    sortColumnName: 'modifiedOn',
    sortDirection: 'desc',
    rows: surveyList,
  };

  const [state, setState] = useState(initialState);

  const sortByName = (sortColumnName, sortDirection) => {
    return _.orderBy(
      surveyList,
      [
        survey =>
          survey[sortColumnName]
            ? survey[sortColumnName].toLowerCase()
            : survey[sortColumnName],
      ],
      [sortDirection]
    );
  };

  const sortByDate = (sortColumnName, sortDirection) => {
    return _.orderBy(
      state.rows,
      o => {
        return new Moment(o[sortColumnName], '"MM/DD/YYYY h:m:s"');
      },
      [sortDirection]
    );
  };

  const handleSort = sortColumnName => {
    let rows = state.rows;
    const sortDirection = state.sortDirection === 'desc' ? 'asc' : 'desc';
    if (sortColumnName === 'modifiedOn') {
      rows = sortByDate(sortColumnName, sortDirection);
    } else {
      rows = sortByName(sortColumnName, sortDirection);
    }
    setState({
      ...state,
      sortColumnName,
      sortDirection,
      rows,
    });
  };

  const getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  };

  setTimeout(() => {
    const hasScroll =
      $('.custom-mri-table--body').get(0).scrollHeight >
      $('.custom-mri-table--body').height();
    if (hasScroll) {
      const scrollWidth = getScrollbarWidth();
      $('.custom-mri-table').addClass('has-scroll');
      $('.custom-mri-table .custom-mri-table--head').attr(
        'style',
        `padding-right: ${scrollWidth}px`
      );
    } else {
      $('.custom-mri-table').removeClass('has-scroll');
      $('.custom-mri-table .custom-mri-table--head').removeAttr('style');
    }
  }, 1000);

  return (
    <div className="ie-survey-table">
      <div className="custom-mri-table">
        <div className="custom-mri-table--head">
          <div className="custom-mri-table--row">
            <div className="custom-mri-table--col ie-column-status">
              <span>Status</span>
              <button
              type="button"
                onClick={() => handleSort('status')}
                className={
                  state.sortColumnName === 'status'
                    ? `custom-mri-table--sort custom-mri-table--sort_${state.sortDirection}`
                    : 'custom-mri-table--sort'
                }
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col ie-column-surveyname">
              <span>Survey Name / Fused Results</span>
              <button
                type="button"
                onClick={() => handleSort('surveyName')}
                className={
                  state.sortColumnName === 'surveyName'
                    ? `custom-mri-table--sort custom-mri-table--sort_${state.sortDirection}`
                    : 'custom-mri-table--sort'
                }
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col ie-column-createdon">
              <span>Last Updates</span>
              <button
                type="button"
                onClick={() => handleSort('modifiedOn')}
                className={
                  state.sortColumnName === 'modifiedOn'
                    ? `custom-mri-table--sort custom-mri-table--sort_${state.sortDirection}`
                    : 'custom-mri-table--sort'
                }
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col ie-column-creator">
              <span>Updated By</span>
              <button
                type="button"
                onClick={() => handleSort('creator')}
                className={
                  state.sortColumnName === 'creator'
                    ? `custom-mri-table--sort custom-mri-table--sort_${state.sortDirection}`
                    : 'custom-mri-table--sort'
                }
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col ie-column-category">
              <span>Category</span>
              <button
                type="button"
                onClick={() => handleSort('categoryName')}
                className={
                  state.sortColumnName === 'categoryName'
                    ? `custom-mri-table--sort custom-mri-table--sort_${state.sortDirection}`
                    : 'custom-mri-table--sort'
                }
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
            <div className="custom-mri-table--col ie-column-surveyid">
              <span>Survey ID</span>
              <button
                type="button"
                onClick={() => handleSort('projectId')}
                className={
                  state.sortColumnName === 'projectId'
                    ? `custom-mri-table--sort custom-mri-table--sort_${state.sortDirection}`
                    : 'custom-mri-table--sort'
                }
              >
                <span className="icon-up" title="Ascending" />
                <span className="icon-down" title="Descending " />
              </button>
            </div>
          </div>
        </div>
        <IESurveyListRows rows={state.rows} />
      </div>
    </div>
  );
};
IESurveyTable.propTypes = {
  surveyList: PropTypes.instanceOf(Array),
};

export default IESurveyTable;
